
import loginMixin from "@/mixins/login"

export default {
  mixins: [loginMixin],

  layoutProps: {
    titleToken: "login.title.recover",
  },

  data: () => ({
    email: "",
    apiErr: "",
    isLoading: false,
    isDone: false,
  }),

  watch: { email () { this.apiErr = "" } },

  methods: {
    async onSubmit () {
      this.isLoading = true
      const [, err] = await this.$api.passwordRecovery
        .initPasswordRecovery(this.email)
      if (!err) this.isDone = true
      else {
        this.apiErr = typeof err === "string"
          ? err
          : Object.values(err)[0] || ""
      }
      this.isLoading = false
    },
  },
}
